import { withIfUser } from '@app/components/common/Routes';
import { hasPermissions } from '@app/utils';
import BudgetDetail from '@app/views/ProjectBudget/Detail';
import { memo } from 'react';

export default memo(
  withIfUser(BudgetDetail)({
    condition: ({ roles }) => roles.some(hasPermissions),
    redirect: true,
    redirectTo: '/unauthorized',
  })
);
